import { AbstractControl, ValidatorFn } from "@angular/forms";

export function VerifyImpactedHost():ValidatorFn {
    
    return (control:AbstractControl): {[key:string]:any} | null => {
        const errmsg={}
        const impactedvalue = control.value;
        if(impactedvalue){
            if(!impactedvalue.selectedHosts.length && !impactedvalue.selectedTags.length){
                errmsg['required'] = true
            }
        }else{
            errmsg['required'] = true
        }
        return errmsg
    }
}